import React from "react"

import { Jumbotron } from 'react-bootstrap'

export default () => {

    return (
        <Jumbotron>
        <p>
            Powered by <a href="https://datarobot.com">DataRobot</a>, and made with ❤️, 🤖, and ☕️ in London, Boston, and a bunch of other cities across the 🌏 // <a href="https://github.com/datarobot-community/movie-rating-app">Source Code on GitHub</a>.
        </p>
        </Jumbotron>
    )
}